import RoomAvailableIndexVue from "@/views/room-available/RoomAvailableIndex.vue";

const roomAvailable = [
  {
    path: "/room-available",
    name: "room-available",
    component: RoomAvailableIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","supervisor"],
      public: false,
    },
  },
];

export default roomAvailable;
